import * as S from "./UserEditMenu.style";
import { UserSideMenus } from "@/data/menus";
import { loginTypeState } from "@/common/states/user";
import { useRecoilValue } from "recoil";
import { UserSideMenuList } from "@/components/molecules/UserSideMenuList";

export const UserSideMenu = () => {
  const loginType = useRecoilValue(loginTypeState);

  return (
    <S.UserSideMenu>
      <UserSideMenuList data={UserSideMenus} loginType={loginType} />
    </S.UserSideMenu>
  );
};
